import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconScreenShareOff",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, f = ["aria-label", "data-qa", "aria-hidden"];
function m(e, r, i, u, _, a) {
  return l(), d("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--screen-share-off"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Screen Share Off",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...r[0] || (r[0] = [
    o("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M.94 1.44A1.5 1.5 0 0 1 2 1h4.5a.5.5 0 0 1 0 1H2a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 2 8h8a.5.5 0 0 0 .5-.5V6a.5.5 0 0 1 1 0v1.5A1.5 1.5 0 0 1 10 9H6.5v1H8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1.5V9H2A1.5 1.5 0 0 1 .5 7.5v-5c0-.398.158-.78.44-1.06Zm7.206-.294a.5.5 0 0 1 .708 0l.896.897.896-.897a.5.5 0 0 1 .708.708l-.897.896.897.896a.5.5 0 0 1-.708.708l-.896-.897-.896.897a.5.5 0 1 1-.708-.708l.897-.896-.897-.896a.5.5 0 0 1 0-.708Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, f);
}
const S = /* @__PURE__ */ s(c, [["render", m]]);
export {
  S as default
};
//# sourceMappingURL=screen-share-off.js.map
